import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { ClaimType } from "../../../provider/pages/business-office/MalpracticeInsurance";
import http from "../../../utils/http";


type Payload = {
  cvKey: string,
  bizEntityProofKey: string,
  medicalLicenseKey: string,
  claims: ClaimType[],
  hasHadMalpracticeLawSuit: boolean,
  currentStatusOfClaim: string,
  fax: string,
  effectiveDate: string,
  expirationDate: string,
  insuranceProvider: string,
  policyNumber: string,
  comments: string,
  coverageLimit: string,
  coverageType: string,
  deductibleAmount: string,
  insuranceResponse: string
}

export const useMalpracticeRegister = () => { 
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationKey: ['malpractice register'],
    mutationFn: async ({ ...data }: Payload) => {
      const response = await http.post("/malpractice-insurance/register", data)
      return response.data;
    },
    onMutate: () => {
      const toastId = toast.loading("Please wait...");
      return { toastId };
    },
    onSuccess: (_data, _variables, context) => {
      const { toastId } = context;
      toast.update(toastId, {
        render: "Malpractice register successfully",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
      })
      queryClient.invalidateQueries({ queryKey: ['malpractice register'] as const});
    },

    onError: (error, _variables, context) => {
      const toastId = context?.toastId as number

      if (axios.isAxiosError(error)) {
        toast.update(toastId, {
          render: error?.response?.data?.error || "Error registering malpractice",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        })

      } else {
        toast.update(toastId, {
          render: error?.message || "Error registering malpractice",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });

      }
    }
  });

  return {
    malpracticeRegister: mutate,
    ...rest,
  };
}
